import { CommonModule } from '@angular/common';
import { Component, HostListener, Input } from '@angular/core';
import { SelectComponent } from "../forms/select/select.component";

@Component({
  selector: 'app-table',
  imports: [CommonModule, SelectComponent],
  templateUrl: './table.component.html',
  styleUrl: './table.component.css'
})
export class TableComponent {

  // Screen
  screenWidth: number = window.innerWidth;
  screenHeight: number = window.innerHeight;

  isSmallScreen: boolean = false;

  // สามารถรับข้อมูลจาก parent ผ่าน input ถ้าต้องการ
  @Input() headers: any[] = []; // หัวตาราง
  @Input() columns: { column: string , type : string , function : any , btColor : string | null , btText : string}[] = []; // ชื่อ .value สำหรับแสดงข้อมูล
  @Input() data: any[] = []; // ข้อมูลสำหรับคำนวณหน้า
  @Input() pagination : boolean = true; // สำหรับโชว์ตัวเลื่อกหน้าข้อมูล
  @Input() height : number = 400;

  // Pagination state
  pageSizeOptions = [
    {name: '5', value: 5},
    { name: '10', value: 10},
    { name: '20', value: 20},
    { name: '50', value: 50}
  ];
  pageSize = {name: '5', value: 5};
  currentPage = 1; // 1-based
  totalItems = 0;
  totalPages = 0;
  heightTable : string = '';

  // Internal slice for current page
  pagedData: any[] = [];

  // Language
  @Input() language = 'th';


  /* ---------------------------------------------------- Function ---------------------------------------------------- */

  ngOnInit(): void {
    // ถ้าไม่มี input จาก parent ให้ใช้ตัวอย่างตัวอย่างข้อมูล
    // if (!this.data || this.data.length === 0) {
    //   this.data = this.getSampleData();
    // }
    // this.totalItems = this.data.length;
    if ( this.pagination ){
       this.calculatePagination();
    }

    if ( this.height > 0 ){
      this.heightTable = this.height + 'px';
      console.log(this.heightTable);
    }

        // ✅ เซ็ตค่าตั้งแต่เริ่ม
    this.getScreenSize();
  }

  @HostListener('window:resize')
  onResize() {
    this.getScreenSize();
  }

  private getScreenSize() {
    this.screenWidth = window.innerWidth;
    this.screenHeight = window.innerHeight;
    console.log(`Current: ${this.screenWidth} x ${this.screenHeight}`);
    if (this.screenWidth < 1024) {
      this.isSmallScreen = true;
    }
    else{
      this.isSmallScreen = false;
    }
  }

  // คำนวณและตัดข้อมูลเพื่อแสดงหน้า
  private calculatePagination() {
    this.totalItems = this.data.length;
    this.totalPages = Math.max(1, Math.ceil(this.totalItems / this.pageSize.value));
    // ป้องกัน currentPage เกินขอบเขต
    if (this.currentPage > this.totalPages) this.currentPage = this.totalPages;
    if (this.currentPage < 1) this.currentPage = 1;

    const start = (this.currentPage - 1) * this.pageSize.value;
    const end = start + this.pageSize.value;
    this.pagedData = this.data.slice(start, end);
  }

   // Controls
  goToPage(page: number) {
    if (page < 1 || page > this.totalPages) return;
    this.currentPage = page;
    this.calculatePagination();
  }

  next() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.calculatePagination();
    }
  }

  prev() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.calculatePagination();
    }
  }

  first() {
    this.currentPage = 1;
    this.calculatePagination();
  }

  last() {
    this.currentPage = this.totalPages;
    this.calculatePagination();
  }

  onPageSizeChange(value: any) {
    //console.log( "PageSize : " , this.pageSize , "SelectValue : " , value);
    this.pageSize = value
    this.currentPage = 1; // reset to first page to avoid out-of-range
    this.calculatePagination();

  }

  // trackBy for ngFor
  trackByIndex(index: number, item: any) {
    // ถ้า data มี id ให้ใช้ id; ที่นี่ใช้ unique string combo
    return `${item.name}-${item.phone}-${index}`;
  }

  // ตัวอย่างข้อมูล (สำหรับ demo)
  private getSampleData(): any[] {
    const arr: any[] = [];
    for (let i = 1; i <= 37; i++) {
      arr.push({
        name: `ลูกค้า ${i}`,
        type: i % 2 === 0 ? 2 : 1,
        phone: `08${(10000000 + i).toString().slice(1)}`,
        plateNumber: i % 2 === 0 ? `กข-${1000 + i}` : '-',
        province: i % 3 === 0 ? 'เชียงใหม่' : 'กรุงเทพฯ',
        brand: i % 2 === 0 ? 'Honda' : 'Toyota',
        model: i % 5 === 0 ? 'Civic' : 'Altis',
        color: i % 3 === 0 ? 'ขาว' : 'ดำ',
        remark: i % 4 === 0 ? 'รถประจำตัว' : ''
      });
    }
    return arr;
  }

  // ใส่ใน CardAdvanceDetailTableComponent class
  getPageWindow(windowSize = 5): number[] {
    const pages: number[] = [];
    const half = Math.floor(windowSize / 2);

    let start = Math.max(1, this.currentPage - half);
    let end = start + windowSize - 1;
    if (end > this.totalPages) {
      end = this.totalPages;
      start = Math.max(1, end - windowSize + 1);
    }

    for (let p = start; p <= end; p++) {
      pages.push(p);
    }
    return pages;
  }
  getPageEnd(): number {
    const end = this.currentPage * this.pageSize.value;
    return end > this.totalItems ? this.totalItems : end;
  }

}
